import { VarSpecial } from '../vars';
import { IErrorFields } from '../error';
import { IRootStore } from '../store/rootStore';
import { SelectorItem } from '../components/Selector';
import { IList } from '../list';

import {
  ConditionCmp,
  ConditionMode,
  MessageConditionServer,
  MessageConditionsServer,
  SqConditionsServer,
  VarConditionServer,
  VarConditionsServer,
  SqConditionServer
} from './server';

export enum ChannelConditionType {
  channel = 'channel',
  group = 'group'
}

export interface IBaseCondition {
  id: string;
}

export interface IBaseConditionModel<S extends Record<string, any>>
  extends IBaseCondition, IErrorFields {
  resetError(): void;
  isEqual(params: IBaseConditionModel<S>): boolean;
  toJson(): S;
}

export interface IConditionsModel<
  C extends IBaseConditionModel<ServerCondition>,
  ServerConditions extends Record<string, any>,
  ServerCondition extends Record<string, any>
> extends IErrorFields {
  readonly conditions: IList<C>;
  readonly mode: ConditionMode;
  readonly rootStore: IRootStore;
  readonly isEmpty: boolean;

  resetError(): void;
  changeMode(value: ConditionMode): void;
  addCondition(): void;
  removeCondition(id: string): void;
  getCopy(): IConditionsModel<C, ServerConditions, ServerCondition>;
  isEqual(
    params: IConditionsModel<C, ServerConditions, ServerCondition>
  ): boolean;
  toJson(): ServerConditions;
}

export interface IVarBaseCondition<K, V> {
  key: K;
  value: V;
  cmp: ConditionCmp;
}

export interface IVarCondition<K, V>
  extends IBaseCondition, IVarBaseCondition<K, V> {}

export interface IVarConditionModel<S extends Record<string, any>, K, V>
  extends IBaseConditionModel<S>, IVarCondition<K, V> {}

export interface ISqBaseCondition {
  expr: string;
}

export interface IVarUnionCondition {
  data: { data: IVarCondition<any, any> };
  readonly actualValue: string;
}

export interface IVarUnionConditionModel
  extends IBaseConditionModel<VarConditionServer>, IVarUnionCondition {}

export interface ISqCondition extends IBaseCondition, ISqBaseCondition {}

export interface ISqConditionModel
  extends IBaseConditionModel<SqConditionServer>, ISqCondition {}

export interface IConditionParamsModel
  extends IBaseConditionParamsModel, IMessageConditionParamsModel {}

export interface IMessageConditionParamsModel {
  messageConditions: IConditionsModel<
    IVarConditionModel<MessageConditionServer, VarSpecial.messageText, string>,
    MessageConditionsServer,
    MessageConditionServer
  >;
}

export interface IBaseConditionParamsModel {
  varConditions: IConditionsModel<
    IVarUnionConditionModel,
    VarConditionsServer,
    VarConditionServer
  >;
  sqConditions: IConditionsModel<
    ISqConditionModel,
    SqConditionsServer,
    SqConditionServer
  >;
}

export type ConditionList = SelectorItem[];
